namespace Entities {

    interface IGroup {
        parentId: string | null;
        name: LanguageValues;
    }

    export class Group
        implements RavenDocument,  IGroup {
        
        id: string = "groups/";
        type?: string;
        
        parentId: string | null;
        name: LanguageValues;

        constructor(group: IGroup) {
            this.parentId = group.parentId;
            this.name = group.name;
        }

        init(){

        }
    }

    export class GroupOrderable
        implements RavenDocument, IGroup, IOrderable {

        id: string = "groupOrderables/";
        parentId: string | null;
        name: LanguageValues;
        quantityPerBunch: number;
        price: number;

        constructor(group: IGroup & IOrderable) {

            this.parentId = group.parentId;
            this.name = group.name;
            this.quantityPerBunch = group.quantityPerBunch;
            this.price = group.price;
        } 
    }

}